// extracted by mini-css-extract-plugin
export default {"headerWrapper":"BU58olKV0G4xfs3iW74I","navigationContainer":"EoqE6RtKUMEiHGEUxOfA","footerWrapper":"_9XrsPbBRWBaNAc2Lp18","footerAction":"LEHWnuGrvm_TZJr9iZwi"};